import script from "./FootContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./FootContent.vue?vue&type=script&setup=true&lang=ts"

import "./FootContent.vue?vue&type=style&index=0&id=45ca3f82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45ca3f82"]])

export default __exports__